import { Component, Input, Output, EventEmitter, ChangeDetectorRef, SimpleChanges, OnChanges, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ChatPerson } from 'common/xislivechat/models/chat-person';
import { ChatPersonsStoreFactory } from 'common/chat-persons-store/chat-persons-store.service';
import { UserContextService } from 'common/user-context/user-context.service';

@Component({
  selector: 'app-chat-actions',
  templateUrl: './chat-actions.component.html',
  styleUrls: ['./chat-actions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChatActionsComponent implements OnChanges, OnDestroy {
  @Input()
  isChatInProgress: boolean;

  @Input()
  isAnswerable: boolean;

  @Input()
  isDisconnected: boolean = false;

  @Input()
  isWrapUpPanelActive: boolean = false;

  @Input()
  messages;

  @Input()
  visitorName: string;

  @Input()
  chatId: string;

  @Output()
  answerChat: EventEmitter<any> = new EventEmitter<any>();

  public typingText: string;

  private _chatPersonsSubscription;

  constructor(private _chatPersonsStore: ChatPersonsStoreFactory,
              private _changeDetector: ChangeDetectorRef,
              private _userContextService: UserContextService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.chatId) {
      this._initChatPersonsSubscription(changes.chatId.currentValue);
    }
  }

  ngOnDestroy(): void {
    this._clearChatPersonsSubscription();
  }

  private _initChatPersonsSubscription(chatId: string): void {
    this._clearChatPersonsSubscription();
    this._chatPersonsSubscription = this._chatPersonsStore.create(chatId)
      .subscribe(chatPersons => this._chatPersonsChanged(chatPersons));
  }

  private _clearChatPersonsSubscription(): void {
    if (this._chatPersonsSubscription) {
      this._chatPersonsSubscription.unsubscribe();
      this._chatPersonsSubscription = null;
    }
  }

  private _chatPersonsChanged(chatPersons: ChatPerson[]): void {
    const isVisitorTyping = chatPersons.some(chatPerson => chatPerson.IsTyping && chatPerson.isVisitor());
    const isOperatorTyping = chatPersons.some(chatPerson => chatPerson.IsTyping && chatPerson.isAgent() && chatPerson.PersonID !== this._userContextService.userContext.id);
    if (isVisitorTyping && isOperatorTyping) {
      this.typingText = 'bcChatActions.typing.visitorAndOperator';
    } else if (isVisitorTyping) {
      this.typingText = 'bcChatActions.typing.visitor';
    } else if (isOperatorTyping) {
      this.typingText = 'bcChatActions.typing.operator';
    } else {
      this.typingText = '';
    }
    this._changeDetector.detectChanges();
  }

  onAnswerChatClick(): void {
    this.answerChat.emit();
  }
}
